import axios from 'axios';
import * as React from 'react';
import {useQuery} from 'react-query';
import Loader from '../../../shared/Loader';
import {useNavigate, useParams} from 'react-router-dom';
import FinlyIFrameForm from "./parts/FinlyIFrameForm";
import FinlyDynamicForm from "./parts/FinlyDynamicForm";
import BackButton from "../../../shared/BackButton";
import Header from "../../../shared/Header";
import Placeholder from "../../../shared/Placeholder";
import {Stack} from "../../../shared/layouts";
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../../hooks/useIconLibrary";
import CompletedForm from "./parts/CompletedForm";


const RenderFormElement = ({finlyFormQueryResult}) => {
    if (finlyFormQueryResult.data.completed_at) {
        return <CompletedForm completed_at={finlyFormQueryResult.data.completed_at}/>;
    }

    if (finlyFormQueryResult.data.v2.is_supported) {
        return <FinlyDynamicForm data={finlyFormQueryResult.data.v2}/>
    }

    return <FinlyIFrameForm queryResult={finlyFormQueryResult}/>
}

const FinlyFormDetailPage = () => {
    const {finlyFormId} = useParams();
    const {t} = useTranslation();
    const {DocumentsIcon} = useIconLibrary();
    const navigate = useNavigate();

    const finlyFormQueryResult = useQuery(
        ['GetFinlyForm', finlyFormId],
        async () => {
            const {data} = await axios.get(`/finly-form/${finlyFormId}`);

            return data;
        },
        {
            refetchOnWindowFocus: false,
        }
    );


    if (finlyFormQueryResult.isLoading) {
        return <Loader/>
    }

    return (
        <Stack space="xl" width={{sm: 656, ml: 672, lg: 800, xl: 1024}}>
            {finlyFormId !== null && (
                <BackButton onClick={() => navigate('/requests')}>
                    {t('Terug')}
                </BackButton>
            )}
            <Header
                title={t('Formulier: {{name}}', {name: finlyFormQueryResult.data?.name ?? ''})}
                icon={<DocumentsIcon height="2rem" width="2rem"/>}
                variant="page"
            />
            {finlyFormQueryResult.isError ? (
                <Placeholder>
                    {t(
                        'Er is iets mis gegaan met het ophalen van dit formulier.'
                    )}
                </Placeholder>
            ) : (
                <Stack space="m">
                    <RenderFormElement finlyFormQueryResult={finlyFormQueryResult}/>
                </Stack>
            )}
        </Stack>
    )
};

export default FinlyFormDetailPage;
